import * as React from "react";
const SvgFiRrCrmAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-crm-alt_svg__a)">
      <path
        fill="#062147"
        d="m20.993 9 .445 6.142a.8.8 0 1 1-1.596.116l-.265-3.66-.849 1.866a.8.8 0 0 1-1.457 0l-.848-1.866-.264 3.66a.8.8 0 0 1-1.596-.116L15.007 9c.043-.705.473-1 .989-1 .341 0 .66.242.84.64l1.165 2.56 1.163-2.56c.181-.398.5-.64.841-.64.517 0 .945.295.988 1M4.273 5.664a9.96 9.96 0 0 1 7.729-3.657c2.173 0 4.262.703 5.983 1.993h-1.983a1 1 0 1 0 0 2h3.015a1.99 1.99 0 0 0 1.985-1.986V1a1 1 0 1 0-2 0l.006 1.278A11.95 11.95 0 0 0 12.002.007a11.95 11.95 0 0 0-9.275 4.389A.998.998 0 0 0 3.5 6.03a1 1 0 0 0 .773-.366m16.812 12.564a1 1 0 0 0-1.408.136 9.97 9.97 0 0 1-7.716 3.643A9.96 9.96 0 0 1 5.958 20H8a1 1 0 1 0 0-2H4.986A1.99 1.99 0 0 0 3 19.985V23a1 1 0 1 0 2 0l-.006-1.236a11.94 11.94 0 0 0 6.967 2.243 11.96 11.96 0 0 0 9.259-4.371 1 1 0 0 0-.136-1.407zm-8.151-5.685.753 2.423c.155.514-.292 1.033-.83 1.033a.8.8 0 0 1-.768-.577l-.705-2.423H10.6v2.2a.8.8 0 1 1-1.6 0v-5.7a1.5 1.5 0 0 1 1.5-1.5h.867c1.284 0 2.456.908 2.614 2.182a2.49 2.49 0 0 1-1.046 2.362zm-.534-2.044c0-.496-.404-.9-.9-.9h-.9v1.8h.9c.496 0 .9-.404.9-.9m-7.079-.883a.9.9 0 0 1 .973.458.8.8 0 1 0 1.41-.757 2.5 2.5 0 0 0-2.28-1.318C4.054 8.04 3 9.234 3 10.603v2.79c0 1.369 1.055 2.563 2.423 2.604a2.5 2.5 0 0 0 2.281-1.318.8.8 0 1 0-1.41-.757.9.9 0 0 1-.973.458c-.427-.083-.72-.482-.72-.918v-2.693c0-.672.292-1.071.72-1.154z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-crm-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCrmAlt;
